export interface TabInterface {
  selected: string | null;
  onTabSelected(selected: string): void;
  isTabSelected(selected: string): boolean;
}

const Tab = (initial: string | null = null): TabInterface => ({
  selected: initial,

  /**
   * Handle the click on the tab.
   *
   * @param selected - The selected tab
   *
   * @returns void
   */
  onTabSelected(selected: string): void {
    this.selected = selected;
  },

  /**
   * Check whether or not the given tab is selected.
   *
   * @param selected - The tab to compare with
   *
   * @returns boolean
   */
  isTabSelected(selected: string): boolean {
    return this.selected === selected;
  },
});

export default Tab;
